import { ChatNote, Circle, Image, Logo, ZStack } from "@/components";
import TruncatedText from "@/components/TruncatedText";
import { CuraiMessageProps } from ".";

const BIO_CONTENT_MAX_LENGTH = 80;

type ClinicianBioProps = Omit<CuraiMessageProps, "content"> & {
  content: string;
};

export default function ClinicianBio({
  content,
  senderFullNameWithTitle,
  senderPhotoUrl,
}: ClinicianBioProps) {
  const Icon = () => {
    const photo = senderPhotoUrl ? (
      <Image
        source={{ uri: senderPhotoUrl }}
        height="$700"
        width="$700"
        borderRadius={100_000}
      />
    ) : (
      <Circle size="$700" backgroundColor="$neutral400" />
    );
    return (
      <ZStack height="$700" width="$700">
        {photo}
        <ZStack
          height={14}
          width={14}
          position="absolute"
          bottom="$50"
          right="$50"
        >
          <Circle
            size={18}
            backgroundColor="$neutral0"
            borderWidth="$strokeWidth"
            borderColor="$neutral100"
            position="absolute"
          />
          <Logo.Only size="$200" position="absolute" />
        </ZStack>
      </ZStack>
    );
  };

  return (
    <ChatNote
      Icon={Icon}
      title={senderFullNameWithTitle ?? "Your Curai Clinician"}
      subtitle={
        <TruncatedText text={content} maxLength={BIO_CONTENT_MAX_LENGTH} />
      }
    />
  );
}
